// extracted by mini-css-extract-plugin
export var chip = "_4r-0";
export var filterDropdown = "_4r-5";
export var filterItem = "_4r-6";
export var icon = "_4r-1";
export var removeButton = "_4r-3";
export var removeIcon = "_4r-4";
export var separator = "_4r-2";